import { Button, Drawer, Spin } from "antd";
import close from "./../../../assets/images/close.svg";

export default function PersonalizeDrawer({
  tags,
  selectedTags,
  handleSelectTag,
  loader,
  show,
  handlePersonalizeDrawer,
  currentCategory,
}: any) {
  return (
    <Drawer
      placement="bottom"
      onClose={handlePersonalizeDrawer}
      closeIcon={false}
      open={show}
      height="90vh"
      className="rounded-t-2xl overflow-hidden"
      style={{ maxWidth: "1280px", margin: "auto" }}
    >
      <div className="flex flex-col h-full">
        {/* Fixed Header */}
        <div className="flex-shrink-0 pb-4 border-gray-200">
          <div className="flex justify-between items-center">
            <div className="font-semibold text-lg">#{currentCategory?.code}</div>
            <img src={close} alt="close" onClick={handlePersonalizeDrawer} />
          </div>
          <div className="text-sm text-gray-600 mt-2">
            Your {currentCategory?.code} feeds will be tuned based on below picks
          </div>
        </div>

        {/* Scrollable Content Area */}
        <div className="flex-1 overflow-y-auto pt-4">
          {loader ? (
            <Spin size="large" className="flex justify-center my-4 items-center" />
          ) : (
            <div className="flex flex-wrap gap-4">
              {tags?.map((tag: any) => (
                <div
                  key={tag?.id}
                  className={`p-2 border ${selectedTags?.[currentCategory?.code]?.includes(tag.id)
                      ? "border-[#3D8C40] bg-[#EDF7ED]"
                      : "border-[#DCE4E8]"
                    } rounded-3xl flex justify-center cursor-pointer`}
                  onClick={() => handleSelectTag(tag.id)}
                >
                  <div
                    className={`font-semibold ${selectedTags?.[currentCategory?.code]?.includes(tag.id)
                        ? "text-[#3D8C40]"
                        : "text-[#5A6774]"
                      }`}
                  >
                    {tag?.tag}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Fixed Save Button */}
        <div className="flex-shrink-0 bg-white pt-6">
          <Button
            type="primary"
            className="w-full bg-[#4B4AD5] p-[16px] h-[58px] rounded-lg text-[18px] font-medium leading-[26px]"
            onClick={handlePersonalizeDrawer}
            disabled={!selectedTags?.[currentCategory?.code]?.length}
          >
            Save
          </Button>
        </div>
      </div>
    </Drawer>
  );
}
